import { validationIsEqual } from '../status';
// import { validateBase64File } from '@om/validation';
import {
    ID_UPLOAD_SET_VALUE,
    KRA_PIN_UPLOAD_SET_VALUE,
    PASSPORT_SET_VALUE,
    setPassportUploadValid,
    setIdUploadValid,
    setKraPinUploadValid,
} from '../../../actions/digitalSavings/Documents';
import { validateBase64File } from '@om/validation';

let prevValidationAction = null;
export const documentsUploadValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case PASSPORT_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'Passport',
                    required: true,
                });
                return setPassportUploadValid(error);

            case ID_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'ID',
                    required: true,
                });
                return setIdUploadValid(error);

            case KRA_PIN_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'KRA PIN Certificate',
                    required: true,
                });
                return setKraPinUploadValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
